'use client';

import { BigNum, PRICE_PRECISION_EXP } from '@drift-labs/sdk';
import { UIMarket } from '@drift/common';
import ValueChangeBlink from 'src/components/Utils/ValueChangeBlink';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { getMarketPriceDecimals } from 'src/constants/marketDecimalConfig';
import { PRICE_FALLBACK_DISPLAY_VALUE } from 'src/components/TradeForm/consts';
import useShowAccountValues from 'src/hooks/useShowAccountValues';
import { AccountOpenPosition } from 'src/@types/positions';

interface LiqPriceCellProps {
	position: AccountOpenPosition;
}

export function LiqPriceCell({ position }: LiqPriceCellProps) {
	const { liqPrice, marketIndex, isIsolatedBalanceOnly } = position;

	const showAccountValues = useShowAccountValues();

	if (isIsolatedBalanceOnly) {
		return <span className="text-text-secondary">-</span>;
	}

	const uiMarket = UIMarket.createPerpMarket(marketIndex);
	const liqPriceBigNum = BigNum.from(liqPrice, PRICE_PRECISION_EXP);

	return (
		<ValueChangeBlink
			value={showAccountValues ? liqPriceBigNum.toNotional(true) : '$ ∗∗∗∗∗∗'}
		>
			{showAccountValues ? (
				liqPriceBigNum.lteZero() ? (
					PRICE_FALLBACK_DISPLAY_VALUE
				) : (
					<NumberDisplay
						value={liqPriceBigNum}
						decimals={getMarketPriceDecimals(uiMarket.baseAssetSymbol())}
						type="currency"
					/>
				)
			) : (
				'$ ∗∗∗∗∗∗'
			)}
		</ValueChangeBlink>
	);
}
